export class TicketHistoryParams {
    public categoryId: number;
    public date: Date;
    public ticketNumber: number;
}